module.exports = __webpack_public_path__ + "static/media/sidebar-create-account-active.d09ba918.svg";